var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30pt",
    height: "30pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2395 4796 c-351 -68 -620 -310 -729 -655 -42 -132 -48 -275 -43 -953 5 -639 5 -644 55 -788 96 -276 322 -493 607 -583 498 -157 1034 136 1175 644 33 120 40 263 40 844 -1 727 -6 777 -105 980 -122 253 -333 423 -613 496 -100 26 -291 34 -387 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 2859 c-33 -13 -68 -47 -86 -81 -20 -39 -18 -165 6 -304 78 -454 351 -827 770 -1053 93 -50 290 -116 390 -132 41 -6 85 -15 98 -20 l22 -9 -2 -317 -3 -318 -212 -5 c-194 -5 -214 -7 -239 -26 -51 -38 -68 -70 -68 -129 0 -59 17 -91 68 -129 27 -21 37 -21 606 -21 569 0 579 0 606 21 51 38 68 70 68 129 0 59 -17 91 -68 129 -25 19 -45 21 -239 26 l-212 5 -3 318 -2 317 22 9 c13 5 57 14 98 20 100 16 297 82 390 132 279 151 504 378 640 648 86 173 150 429 150 606 0 90 -16 127 -73 169 -38 28 -126 28 -164 0 -50 -38 -66 -78 -74 -193 -24 -308 -134 -547 -346 -752 -166 -160 -346 -257 -568 -304 -109 -24 -341 -24 -450 0 -389 83 -710 358 -844 723 -40 107 -71 262 -71 349 0 77 -26 143 -70 175 -31 22 -106 31 -140 17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.c65bf9cd17306ebb254dc424ccbe5eba.svg";
export { ForwardRef as ReactComponent };